export const CP10PolicyOption: PolicyOptions[] = [
    { key: 'B', value: 'B (High)' }];

export const CP12PolicyOption: PolicyOptions[] = [{ key: '1', value: '1 unit'},  { key: '2', value: '2 units'}, { key: '3', value: '3 units'}];

export type PolicyOptions = {
    key: string,
    value: string
}